import { Globe } from 'lucide-react';

import { SourceChip } from './SourceChip';

export interface DescriptionLabelRowProps {
  /** Set when the row labels an input; the label then points at it. */
  inputId?: string;
  /** Null when no chip should show (the text is Nebari's own and was never synced). */
  source: 'fareharbor' | 'staff' | null;
  who: string | null;
}

/** "Description", where customers see it, and where the text came from. */
export function DescriptionLabelRow({ inputId, source, who }: DescriptionLabelRowProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        marginBottom: inputId ? 5 : 3,
      }}
    >
      {inputId ? (
        <label
          htmlFor={inputId}
          style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}
        >
          Description
        </label>
      ) : (
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '.05em',
            textTransform: 'uppercase',
            color: 'var(--nb-subtle)',
          }}
        >
          Description
        </span>
      )}
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          fontSize: 10.5,
          color: 'var(--nb-muted)',
        }}
      >
        <Globe size={11} aria-hidden="true" />
        Customers see this as “About the venue”
      </span>
      <span style={{ flex: 1 }} />
      {source && <SourceChip kind="description" source={source} who={who} />}
    </div>
  );
}
